export default __webpack_public_path__ + "static/media/offices.e8dfc0a0.png";